export const V2_ASSISTANT_INTENTS = Object.freeze({
  foodSearch: "food_search",
  dashboardSummary: "dashboard_summary",
  historySummary: "history_summary",
  knowledgeSearch: "knowledge_search",
  reminderHelp: "reminder_help",
  appHelp: "app_help",
  generalQuestion: "general_question",
  blockedWriteAction: "blocked_write_action",
  urgentHealthMessage: "urgent_health_message",
});

const ARABIC_TEXT_PATTERN = /[\u0600-\u06ff]/;
const URGENT_PATTERN =
  /\b(chest pain|trouble breathing|difficulty breathing|shortness of breath|can't breathe|cannot breathe|fainting|fainted|passed out|severe weakness|emergency|medical emergency|call ambulance|go to hospital)\b|ألم\s*صدر|وجع\s*صدر|ضيق\s*تنفس|صعوبة\s*تنفس|مش\s*قادر\s*اتنفس|مش\s*قادر\s*أتنفس|إغماء|اغماء|ضعف\s*شديد|طوارئ/iu;
const BLOCKED_WRITE_PATTERN =
  /\b(log|record|add|save|register|create|insert|submit|store)\s+(a\s+|an\s+|my\s+|this\s+|the\s+)?(food|meal|snack|apple|rice|chicken|milk|cheese|cucumber|tabouleh|custom food)\b|\b(add|save|create|schedule|set)\s+(a\s+|my\s+|the\s+)?(medication|medicine|reminder|timer)\b|\b(i ate|i had|ate|had)\s+(an?\s+|some\s+)?(apple|rice|chicken|milk|cheese|cucumber|tabouleh|food|meal)\b|سجل|سجّل|ضيف|أضف|اضف|أكلت|اكلت|تم\s*تسجيل/iu;
const HISTORY_PATTERN =
  /\b(what\s+(?:did\s+)?i\s+eat\s+today|what\s+have\s+i\s+eaten\s+today|what\s+foods\s+(?:did\s+i\s+eat|i\s+ate)\s+today|show\s+(?:what\s+i\s+ate\s+today|today'?s\s+food\s+logs?)|what\s+(?:did\s+i\s+log|have\s+i\s+logged)\s+today|what\s+foods\s+did\s+i\s+log|what\s+did\s+i\s+eat|what\s+have\s+i\s+eaten|foods?\s+(recorded|entered)\s+today|food\s+history|history|recent\s+food|today'?s\s+food|14-day|14\s+day|30-day|30\s+day|last\s+14|last\s+30)\b|ماذا\s+أكلت\s+اليوم|ماذا\s+اكلت\s+اليوم|شو\s+أكلت\s+اليوم|شو\s+اكلت\s+اليوم|شو\s+سجلت\s+اليوم|سجل\s+الأكل|سجل\s+الاكل/iu;
const DASHBOARD_PATTERN =
  /\b(dashboard|summary|remaining|remain|consumed|used|target|limit|limits|percentage|percent|potassium|phosphorus|sodium|protein|watch\s+today|safety)\b|كم\s+بقي|شو\s+ضايل|باقي|بوتاسيوم|فوسفور|صوديوم|بروتين|ملخص|معدلات\s+اليوم|أراقب\s+اليوم|اراقب\s+اليوم/iu;
const KNOWLEDGE_PATTERN =
  /\b(knowledge base|knowledge|approved tips?|tips?|manual notes?|notes?|pdf|docx|markdown|source|what does.*say about|search knowledge)\b|قاعدة\s+المعرفة|نصائح|ملاحظات|مصدر/iu;
const REMINDER_PATTERN = /\b(reminder|medication|medicine|timer|whatsapp|notification)\b|تذكير|دواء|أدوية|ادوية|واتساب|اشعار|إشعار/iu;
const FOOD_NUTRIENT_QUESTION_PATTERN =
  /\b(?:is|are)\s+.+?\s+(?:high|low)\s+in\s+(?:potassium|phosphorus|sodium|protein|nutrients?|nutrition)\b|\bhow\s+much\s+(?:potassium|phosphorus|sodium|protein)\s+(?:is|are)\s+(?:there\s+)?in\s+.+|\bdoes\s+.+?\s+(?:contain|have)\s+(?:potassium|phosphorus|sodium|protein|nutrients?)\b|\bwhat\s+(?:nutrients?|nutrition)\s+(?:is|are)\s+in\s+.+|هل\s+.+?\s+(?:غني|غنية|عال|عالي|عالية|منخفض|منخفضة|قليل|قليلة)\s*(?:ب|بال|في)?\s*(?:البوتاسيوم|الفوسفور|الصوديوم|البروتين|العناصر\s+الغذائية)|كم\s+(?:يوجد\s+من\s+)?(?:البوتاسيوم|الفوسفور|الصوديوم|البروتين)\s+في\s+.+|هل\s+.+?\s+(?:يحتوي|تحتوي)\s+(?:على\s+)?(?:البوتاسيوم|الفوسفور|الصوديوم|البروتين|عناصر\s+غذائية)|ما\s+(?:هي\s+)?(?:العناصر\s+الغذائية|المغذيات)\s+في\s+.+/iu;
const FOOD_NUTRIENT_COMPARISON_PATTERN =
  /\b(?:compare|comparison|versus|vs\.?)\b.*\b(?:potassium|phosphorus|sodium|protein|nutrients?|nutrition)\b|\b(?:potassium|phosphorus|sodium|protein|nutrients?|nutrition)\b.*\b(?:compare|comparison|versus|vs\.?)\b|(?:قارن|مقارنة|مقابل).*?(?:البوتاسيوم|الفوسفور|الصوديوم|البروتين|العناصر\s+الغذائية)/iu;
const FOOD_NUTRIENT_LIST_PATTERN =
  /\b(?:show|list|find|suggest)\s+(?:me\s+)?(?:foods?|options?)\s+(?:that\s+are\s+)?(?:high|low)\s+in\s+(?:potassium|phosphorus|sodium|protein)\b|(?:اعرض|أظهر|اظهر|اقترح).*?(?:أطعمة|اطعمة|خيارات).*?(?:غنية|عالية|منخفضة|قليلة).*?(?:البوتاسيوم|الفوسفور|الصوديوم|البروتين)/iu;
const FOOD_SEARCH_PATTERN =
  /\b(search|find|look up|show|available foods?|foods available|food list|nutrients?|nutrition|serving|apple|cucumber|chicken|rice|milk|cheese|tabouleh)\b|فتش|ابحث|دور|تفاح|التفاح|رز|دجاج|حليب|جبنة|جبن|خيار|أطعمة|اطعمة/iu;
const EXPLICIT_APP_HELP_PATTERN = /\b(how do i|how to|where do i|use the app|app help)\b|كيف|وين/iu;
const APP_HELP_PATTERN = /\b(help|how do i|how to|where do i|use the app|settings|mixer|custom food|manual)\b|مساعدة|كيف|وين/iu;
const READ_ONLY_ARABIC_PREFIX = /^\s*(شو|فتش|ابحث|دور|اشرح|كيف|وين|كم|ماذا|ما)\b/u;

export function detectAssistantLanguage(message = "") {
  return ARABIC_TEXT_PATTERN.test(String(message)) ? "ar" : "en";
}

export function routeV2AssistantIntent(message = "") {
  const text = String(message || "").trim();

  if (!text) {
    return {
      intent: V2_ASSISTANT_INTENTS.appHelp,
      language: "en",
      query: "",
    };
  }

  const language = detectAssistantLanguage(text);

  if (URGENT_PATTERN.test(text)) {
    return { intent: V2_ASSISTANT_INTENTS.urgentHealthMessage, language, query: text };
  }

  if (HISTORY_PATTERN.test(text)) {
    return { intent: V2_ASSISTANT_INTENTS.historySummary, language, query: text };
  }

  if (isBlockedWriteAction(text)) {
    return { intent: V2_ASSISTANT_INTENTS.blockedWriteAction, language, query: text };
  }

  if (EXPLICIT_APP_HELP_PATTERN.test(text)) {
    return { intent: V2_ASSISTANT_INTENTS.appHelp, language, query: text };
  }

  if (KNOWLEDGE_PATTERN.test(text)) {
    return { intent: V2_ASSISTANT_INTENTS.knowledgeSearch, language, query: text };
  }

  if (
    FOOD_NUTRIENT_QUESTION_PATTERN.test(text) ||
    FOOD_NUTRIENT_COMPARISON_PATTERN.test(text) ||
    FOOD_NUTRIENT_LIST_PATTERN.test(text)
  ) {
    return { intent: V2_ASSISTANT_INTENTS.foodSearch, language, query: text };
  }

  if (DASHBOARD_PATTERN.test(text)) {
    return { intent: V2_ASSISTANT_INTENTS.dashboardSummary, language, query: text };
  }

  if (FOOD_SEARCH_PATTERN.test(text)) {
    return { intent: V2_ASSISTANT_INTENTS.foodSearch, language, query: text };
  }

  if (REMINDER_PATTERN.test(text)) {
    return { intent: V2_ASSISTANT_INTENTS.reminderHelp, language, query: text };
  }

  return { intent: V2_ASSISTANT_INTENTS.generalQuestion, language, query: text };
}

export function isBlockedWriteAction(message = "") {
  const text = String(message || "").trim();
  if (!text) return false;

  if (/^\s*(what|show|list|find|search|explain|how|why|where|when)\b/i.test(text)) {
    return false;
  }

  if (READ_ONLY_ARABIC_PREFIX.test(text)) {
    return false;
  }

  return BLOCKED_WRITE_PATTERN.test(text);
}
